import { render, staticRenderFns } from "./IconUserAddSolid.vue?vue&type=template&id=51ed931e"
import script from "./IconUserAddSolid.vue?vue&type=script&lang=js"
export * from "./IconUserAddSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports